import React, { createContext, useState, ReactNode } from 'react'
import { RecursoRow } from '../interfaces/ConfiguracionRecursos.interfaces'

export type ModoModalRecurso = 'crear' | 'editar' | 'ver' | null

interface RecursosContextProps {
    rows: RecursoRow[]
    setRows: React.Dispatch<React.SetStateAction<RecursoRow[]>>
    loadingTable: boolean
    setLoadingTable: React.Dispatch<React.SetStateAction<boolean>>
    modalOpen: boolean
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    modo: ModoModalRecurso
    setModo: React.Dispatch<React.SetStateAction<ModoModalRecurso>>
    recursoSelected: RecursoRow | null
    setRecursoSelected: React.Dispatch<React.SetStateAction<RecursoRow | null>>
    /**
     * Estación por la que está filtrado el listado (null = todas). Vive en el
     * contexto para que cualquier refresco (crear, editar, cambiar estado)
     * respete el filtro activo, sin importar desde qué componente se dispare.
     */
    empresaFiltro: number | null
    setEmpresaFiltro: React.Dispatch<React.SetStateAction<number | null>>
}

export const RecursosContext = createContext<RecursosContextProps | undefined>(undefined)

export const RecursosProvider = ({ children }: { children: ReactNode }) => {
    const [rows, setRows] = useState<RecursoRow[]>([])
    const [loadingTable, setLoadingTable] = useState<boolean>(false)
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const [modo, setModo] = useState<ModoModalRecurso>(null)
    const [recursoSelected, setRecursoSelected] = useState<RecursoRow | null>(null)
    const [empresaFiltro, setEmpresaFiltro] = useState<number | null>(null)

    return (
        <RecursosContext.Provider
            value={{
                rows, setRows,
                loadingTable, setLoadingTable,
                modalOpen, setModalOpen,
                modo, setModo,
                recursoSelected, setRecursoSelected,
                empresaFiltro, setEmpresaFiltro,
            }}
        >
            {children}
        </RecursosContext.Provider>
    )
}